import { IS_BROWSER } from 'redux-bundler'

export default IS_BROWSER &&
  (window.navigator.userAgent.indexOf('MSIE ') !== -1 ||
    window.navigator.userAgent.indexOf('Trident/') !== -1)
